/* istanbul ignore file */
import React from 'react';
import { useFieldHelper, TextField, LinkField, FieldProps } from 'framework/ui/field';
import { copyToClipboard } from 'framework/ui/clipboard';
import CopyIcon from '@mui/icons-material/ContentCopyOutlined';
import { Button } from 'framework/ui/mui-builder';
import { useJournalEntryUrl } from 'domain/finance/journalEntry/shared/useJournalEntryRouting';

const JournalEntryTransferField = ({ source, ...props }: FieldProps) => {
  const { getValue } = useFieldHelper({ source });
  const id = getValue();
  const { getJournalEntryByTransferUrl } = useJournalEntryUrl();

  return (
    <TextField
      {...props}
      source={source}
      value={
        <>
          <LinkField linkText={id} isInternal value={id ? getJournalEntryByTransferUrl(id) : null} {...props} />
          <Button
            variant="text"
            onClick={() => {
              copyToClipboard(id);
            }}
            id="copy-main"
            className="copy-anchor"
            sx={{
              minWidth: '10px',
              marginLeft: '5px',
              marginBottom: '-6px',
              marginTop: '-8px',
              p: '4px 5px',
              '& .MuiSvgIcon-root': {
                width: '18px',
                height: '18px',
              },
            }}
          >
            <CopyIcon />
          </Button>
        </>
      }
    />
  );
};

export default JournalEntryTransferField;
